// removed by extract-text-webpack-plugin
module.exports = {"small-banner":"banners--small-banner--1KsjvCK0","smallBanner":"banners--small-banner--1KsjvCK0","split-banners":"banners--split-banners--phC2rbiJ","splitBanners":"banners--split-banners--phC2rbiJ","no-credit":"banners--no-credit--2LP4N2HZ","noCredit":"banners--no-credit--2LP4N2HZ"};


//////////////////
// WEBPACK FOOTER
// ./components/banners/styles.css
// module id = ./components/banners/styles.css
// module chunks = 0